export default "* Kronvildt\n* Hjort\n* Hind\n* Kalv\n* Rudel\n";